import { motion } from "framer-motion";
import { useSiteSettings, type SiteSettings } from "@/hooks/useSiteSettings";

const defaultFoodShowcase = "https://images.unsplash.com/photo-1490818387583-1baba5e638af?auto=format&fit=crop&q=80&w=1000";

const FeaturesSection = () => {
  const { data } = useSiteSettings();
  const settings = data as SiteSettings | null;
  const foodShowcase = settings?.features_image || defaultFoodShowcase;
  return (
    <section className="py-20 bg-secondary/30 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-64 h-64 bg-primary/3 rounded-full blur-[80px]" />
        <div className="absolute bottom-0 right-0 w-80 h-80 bg-accent/3 rounded-full blur-[80px]" />
      </div>
      <div className="container mx-auto px-4 flex flex-col-reverse md:flex-row items-center gap-12 relative z-10">
        <motion.div
          className="flex-1 flex justify-center"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
        >
          <img
            src={foodShowcase}
            alt="تشكيلة منتجات جنّة الغذائية"
            width={900}
            height={700}
            loading="lazy"
            className="w-full max-w-lg drop-shadow-xl rounded-2xl"
          />
        </motion.div>
        <motion.div
          className="flex-1 text-center md:text-right"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl md:text-4xl font-cairo font-extrabold text-foreground mb-6">
            🌿 جنّة – <span className="text-gradient">طبيعي 100%، جودة لا تُضاهى</span>
          </h2>
          <ul className="space-y-5 text-lg text-muted-foreground font-cairo">
            {[
              { icon: "✅", bold: "منتجات أساسية من أفضل المصادر", text: " – دقيق، سكر، مكرونات، وتوابل بأعلى معايير الجودة." },
              { icon: "✅", bold: "بدون مواد حافظة أو إضافات صناعية", text: " – صحة عائلتك هي أولويتنا." },
              { icon: "✅", bold: "أسعار تنافسية وتوصيل سريع", text: " – احصل على أجود المنتجات حتى باب بيتك!" },
            ].map((item, i) => (
              <motion.li
                key={i}
                className="flex items-start gap-3 justify-center md:justify-start flex-row-reverse md:flex-row bg-card/50 rounded-xl p-4 border border-border/50"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.15, duration: 0.4 }}
              >
                <span className="text-2xl">{item.icon}</span>
                <span><strong className="text-foreground">{item.bold}</strong>{item.text}</span>
              </motion.li>
            ))}
          </ul>
          <motion.p
            className="mt-6 text-lg font-cairo font-bold text-gradient inline-block"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.5 }}
          >
            🍯 جنّة... طعم الطبيعة الحقيقي في كل لقمة!
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
};

export default FeaturesSection;
